import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getTrackerSettingsAll = createAsyncThunk(
    "trackerSettings/getTrackerSettingsAll",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/trackers/settings`,
            RequestConfig(),
        );
        return response.data && response.data.data;
    },
);

export const getTrackerSettings = createAsyncThunk(
    "trackerSettings/getTrackerSettings",
    async ({ id }) => {
        const response = await axios.get(
            `${baseURL}/api/trackers/settings/${id}`,
            RequestConfig(),
        );
        return response.data && response.data.data;
    },
);

export const putTrackerSettings = createAsyncThunk(
    "trackerSettings/putTrackerSettings",
    async ({ id, selectedCodes }) => {
        const response = await axios.put(
            `${baseURL}/api/trackers/settings/${id}`,
            { codes: selectedCodes },
            RequestConfig(),
        );
        return response.data && response.data.data;
    },
);
